import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import AdminLoading from './AdminLoading';
import AdminEmptyState from './AdminEmptyState';
import { IoListOutline } from 'react-icons/io5';

export default function AdminActivity() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filterAction, setFilterAction] = useState('');
  const [filterStaffId, setFilterStaffId] = useState('');

  const load = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filterAction) params.set('action', filterAction);
    if (filterStaffId) params.set('staff_id', filterStaffId);
    params.set('limit', '100');
    api('/api/admin/activity?' + params.toString())
      .then(setList)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => load(), [filterAction, filterStaffId]);

  const formatDate = (d) => (d ? new Date(d).toLocaleString() : '–');

  if (loading) return <AdminLoading />;

  return (
    <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
      <CardHeader title="Activity log" />
      <CardContent>
        {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
          <TextField
            size="small"
            label="Action"
            value={filterAction}
            onChange={(e) => setFilterAction(e.target.value)}
            placeholder="e.g. login"
            sx={{ minWidth: 140 }}
          />
          <TextField
            size="small"
            label="Staff ID"
            value={filterStaffId}
            onChange={(e) => setFilterStaffId(e.target.value)}
            sx={{ minWidth: 100 }}
          />
        </Box>
        {list.length === 0 ? (
          <AdminEmptyState message="No activity yet." icon={IoListOutline} />
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Time</TableCell>
                  <TableCell>Staff</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Entity</TableCell>
                  <TableCell>Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((a) => (
                  <TableRow key={a.id} hover>
                    <TableCell>{formatDate(a.created_at)}</TableCell>
                    <TableCell>{a.staff_name || a.staff_email || a.staff_id}</TableCell>
                    <TableCell>{a.action}</TableCell>
                    <TableCell>{a.entity_type && a.entity_id ? `${a.entity_type} #${a.entity_id}` : '–'}</TableCell>
                    <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {a.details ? (typeof a.details === 'string' ? a.details : JSON.stringify(a.details)) : '–'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}
